import React from 'react';
import ClipboardButton from 'react-clipboard.js';
import copy from 'assets/copy.svg-inline'
import { toastr } from 'react-redux-toastr'
const Link = (props) => {
  const url = props.url;
  return (
      <div className="link">
        <div className="link__url">{url}</div>
        <div className="link--inline">
          <ClipboardButton component="div"
                           data-clipboard-text={`http://lc.chat/${props.hash}`}
                           onSuccess={() => toastr.success('Link copied', 'Your link has been copied to your clipboard')}>
            <div className="link__shortcut">
              lc.chat/{props.hash}
              <div className="link__shortcut__copy">Copy <span
                  dangerouslySetInnerHTML={{ __html: copy }}></span></div>
            </div>
          </ClipboardButton>
          <div className="link__stats">{props.clicks}</div>
        </div>
      </div>
  );
};

export default Link;


// WEBPACK FOOTER //
// ./src/components/link.jsx